<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12 mt-5 d-flex justify-content-center">
        <img
          src="../../../assets/img/modalIcon.svg"
          alt="modalIcon"
          class="img-fluid top__img"
        />
      </div>
      <div class="col-md-12 mt-5 text-center">
        <p class="mb-0">Almost there!</p>
        <p>Please enter your 4 digit bot ID</p>
      </div>
      <div class="col-md-12 mt-3">
        <form
          #form_mapping="ngForm"
          class="form_mapping"
          id="form_mapping"
          name="form_mapping"
        >
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Bot ID"
              id="botid"
              [(ngModel)]="botid"
              name="botid"
              minlength="4"
              maxlength="4"
              pattern="\d{10}"
              required
            />
          </div>
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Confirm Bot ID"
              id="confirmbotid"
              [(ngModel)]="confirmbotid"
              name="confirmbotid"
              minlength="4"
              maxlength="4"
              pattern="\d{10}"
              required
            />
          </div>

          <div class="opt_btn">
            <button
              type="button"
              class="btn btn-danger w-100"
              (click)="mapping()"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
      <div class="col-md-12 mt-5">
        <!-- <p class="mt-2">
          Your number is not paired with any Ohm-bot.<br />Please contact
          support and the team shall try to resolve on a priority basis.<br />You
          are important to us.
        </p> -->
        <div class="verify_btn mt-5">
          <div class="row">
            <div class="col-md-6 mt-2">
              <a
                href="https://api.whatsapp.com/send?phone=+91-7777067346"
                target="_blank"
                ><button type="button" class="btn btn-danger w-100 p-1">
                  Click here to contact us
                </button></a
              >
            </div>
            <div class="col-md-6 mt-2">
              <a href="#" routerLink="/login"
                ><button type="button" class="btn btn-danger w-100 p-1">
                  Sign in with other number
                </button></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
